<template>
	<div>
		<Clist :ShowFilas="false" :pShowBtnAdd="false" :regresar="false" :Nombre="NameList" :Pag="Pag" :Total="TotalPagina" @FiltrarC="Lista" :Filtro="Filtro" :pConfigLoad="ConfigLoad" :ShowBusqueda="true">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label for="">Cliente</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="Lista();"
						:options="ListaClientes"
						placeholder="Busque un Cliente..."
						v-model="Filtro.IdSucursal"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div class="form-group-mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="Ciudad..." v-model="Filtro.Ciudad" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<label for="">Tipo</label>
				</div>
				<div class="form-group mr-2">
					<select @change="Lista()" class="form-control" v-model="Filtro.Tipo">
						<option value="">-Tipo-</option>
						<option value="Material">Material</option>
						<option value="Equipo">Equipo</option>
						<option value="Refacción">Refacción</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label for="">Proveedores</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="Lista();"
						:options="ListaProveedores"
						placeholder="Busque un Proveedor..."
						v-model="Filtro.IdUsuario"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div style="width:32%" class="d-flex justify-content-end">
					<h1 class="naranja text-center">${{formateoMillon(parseFloat(Total))}}</h1>
				</div>
			</template>
			<template slot="header">
				<tr>
					<th>Cotización</th>
					<th>Cliente</th>
					<th>Ciudad</th>
					<th>Tipo</th>
					<th>Item</th>
					<th>Proveedor</th>
					<th>SKU</th>
					<th>Marca</th>
					<th>Modelo</th>
					<th>Cantidad</th>
					<th>Costo Unitario</th>
					<th>Estatus</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,index) in ListaSolicitud" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaCotiServicio,false)}}</td>
					<td>{{item.Cliente}}</td>
					<td>{{item.Ciudad}}</td>
					<td>{{item.Tipo}}</td>
					<td>{{item.Item}}</td>
					<td>{{item.Clasificacion}}</td>
					<td>{{item.Sku}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Cantidad}}</td>
					<td>$ {{item.CostoUnitario}}</td>
					<td>{{item.EstatusDistribuidor}}</td>
					<td>
						<button @click="EditarEstatus(item)" data-toggle="modal" :data-target="'#Solicitud'" data-backdrop="static" v-b-tooltip.hover.top :title="'Editar Estatus'" type="button" class="btn-icon mr-2" ><i class="fa fa-pencil"></i></button>
					</td>
				</tr>
			</template>
		</Clist>
		<Modal :Showbutton="true" :size="'modal-md'" :Nombre="'Estatus'" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion" :NameModal="'Solicitud'">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import CSinRegistros from "@/components/CSinRegistros";
import Form from '@/views/modulos/distribuidor/solicitudes/Form.vue'

export default {
	name :'listSolicitudes',
	components :{
        Modal,
        Clist,
        Cbtnaccion,
		CSinRegistros,
		Form
    },
	data() {
		return {
			EmitSeccion:'Solicitud',
            FormName:'Solicitud',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-xl",
			NameList:"Cotizaciones",
            NameForm:"Solicitud",
			ListaSolicitud:[],
			regresar:false,
			btnadd:false,
			Filtro:{
                Nombre:'',
                Placeholder:'SKU..',
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				IdSucursal:null,
				IdUsuario:null,
				Descripcion:'',
				Tipo:'',
				Ciudad:''
            },
			oBtnSave:{
				//valores  isModal(true),nombreModal('ModalForm'),tipoModal=1,regresarA(''),disableBtn(false),txtSave('Guardar'),txtCancel('Cerrar');
                isModal:true,
                disableBtn:false,
                toast:0,
				EmitSeccion:'Solicitud',
				nombreModal:'Solicitud',
            },
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			ListaClientes:[],
			ListaProveedores:[],
			TimeOut:null,
			Total:0
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('sucursalxdistribuidorsolicitud/get',{
				params:{
					Codigo:this.Filtro.Nombre,
					Tipo:this.Filtro.Tipo,
					Entrada:this.Filtro.Entrada,
					IdSucursal:this.Filtro.IdSucursal,
					IdUsuario:this.Filtro.IdUsuario,
					Ciudad:this.Filtro.Ciudad,
					pag:this.Filtro.Pagina
				}
			}).then((res)=>{
				this.ListaSolicitud=res.data.data.solicitudes;
				this.Total=res.data.data.total;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		async GetListaClientes(){
			this.$http.get('sucursalxdistribuidor/getsimple').then((res)=>{
				this.ListaClientes=res.data.data.rows.map((value) => {
					return {
						id:value.IdSucursal,
						label:value.Nombre
					}
				})
			})
		},
		EditarEstatus(item){
			let Id=0;
			let IdDistribuidor=0;
			let Tipo='';
			switch (item.Tipo) {
				case 'Material':
					Id=item.IdMaterial;
					IdDistribuidor=item.IdMaterialDistribuidor;
					Tipo='material';
					break;
				case 'Equipo':
					Id=item.IdEquipoCot;
					IdDistribuidor=item.IdEquipoCotDistribuidor;
					Tipo='equipo';
					break;
				case 'Refacción':
					Id=item.IdRefaccion;
					IdDistribuidor=item.IdRefaccionDistribuidor;
					Tipo='refaccion';
					break;
				default:
					break;
			}
			this.bus.$emit('NewModal_'+this.EmitSeccion,Id,IdDistribuidor,Tipo,item.IdCotizacionServicio,item.EstatusDistribuidor);
		},
		async GetListaProveedores(){
			await this.$http.get('sucursalxdistribuidor/getprov',{
				params:{
					// IdSucursal:this.Sucursal.IdSucursal
				}
			}).then((res)=>{
				this.ListaProveedores=res.data.data.todos.map((value) => {
					return {id:value.IdUsuario,label:value.Usuario}
				});
				this.ListaProveedores.push({id:0,label:'Otros'});
			})
		},
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
	},
	mounted() {
		this.Lista();
		this.bus.$off('List_'+this.EmitSeccion);
		this.bus.$on('List_'+this.EmitSeccion,()=>{
			this.Lista();
		});
		this.GetListaClientes();
		this.GetListaProveedores();
	},
}
</script>

<style>

</style>
